import { RangerChat } from "frontend/src/components/RangerChat";
import Drawer from "@mui/material/Drawer";
import { useStore } from "react-admin";
import Typography from "@mui/material/Typography";
import { useCustomHeaderEffect } from "./useCustomHeaderEffect";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
// Import expand/collapse icons
import ExpandIcon from "@mui/icons-material/ChevronLeft";
import CollapseIcon from "@mui/icons-material/ChevronRight";
import { Tooltip } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const CHAT_WIDTH = 400;
const CHAT_EXPANDED_WIDTH = 800;

/** Width of the page's right edge covered by the chat drawer; 0 while it is closed. */
export const useChatDrawerWidth = () => {
  const [showChat] = useStore("showChat", false);
  const [isExpanded] = useStore("chatExpanded", false);
  if (!showChat) return 0;
  return isExpanded ? CHAT_EXPANDED_WIDTH : CHAT_WIDTH;
};

export const RangerChatSidebar = () => {
  const [showChat, setShowChat] = useStore("showChat", false);
  const { headerHeight } = useCustomHeaderEffect();
  // Kept in the store so the layout can make room for the drawer
  const [isExpanded, setIsExpanded] = useStore("chatExpanded", false);
  const drawerWidth = useChatDrawerWidth();

  if (!showChat) return null;
  return (
    <Drawer
      anchor="right"
      open={showChat}
      onClose={() => setShowChat(false)}
      hideBackdrop
      ModalProps={{
        keepMounted: true,
        style: { pointerEvents: "none" }, // allow pointer events to pass through
      }}
      PaperProps={{
        sx: {
          width: drawerWidth, // Use dynamic width
          maxWidth: "100vw",
          boxShadow: 3,
          // below the app bar, like the menu, so the app bar's controls stay reachable
          top: `${headerHeight}px`,
          height: `calc(100% - ${headerHeight}px)`,
          position: "fixed",
          pointerEvents: "auto", // enable pointer events for drawer content
          transition: "width 0.3s ease", // Add smooth transition
        },
      }}
      variant="persistent"
    >
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          style={{
            padding: "16px",
            borderBottom: "1px solid #eee",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={() => setIsExpanded(!isExpanded)}
            title={isExpanded ? "Collapse Chat" : "Expand Chat"}
            size="small"
          >
            {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
          </IconButton>
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div>
              <span style={{ fontSize: "14px", marginRight: "4px" }}>
                Sirius AI
              </span>
            </div>
            <Tooltip title="AI-powered">
              <AutoAwesomeIcon color="primary" />
            </Tooltip>
          </Typography>
          <Box>
            <IconButton
              onClick={() => setShowChat(false)}
              title="Close Chat"
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </div>
        <div style={{ flex: 1, overflow: "auto" }}>
          <RangerChat params={{}} />
        </div>
      </div>
    </Drawer>
  );
};
